import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps, Switch, useHistory } from 'react-router-dom';

import { PATHS } from 'src/appConfig/paths';
import { Screen } from 'src/components/common';
import Navbar from 'src/components/Navbar';
import { Navigator } from 'src/services';
import { IAppState } from 'src/store';
import Dev from './Dev';
import Home from './Home';

// import { SidebarMenu } from 'src/appConfig/sidebar';
// import { hasPagePermission } from 'src/validations/permissions';
import Signin from './Signin';
import Sidebar from 'src/components/Sidebar';
import ModalContainer from './StartupContainers/ModalContainer';
import NotFound from './StartupContainers/NotFound';
import SplashScreen from './StartupContainers/SplashScreen';
import ContentContainer from './StartupContainers/ContentContainer';
import LoadingContainer from './StartupContainers/LoadingContainer';
import ToastContainer from './StartupContainers/ToastContainer';
import ManageUsers from './ManageUsers/ManageUsers';
import AuthContainer from './StartupContainers/AuthContainer';
import ResponsiveContainer from './StartupContainers/ResponsiveContainer';
// import PermissionScreen from './StartupContainers/PermissionScreen';
import ManageDepositions from './ManageDepositions/DepositionList';
import DepositionDetail from './ManageDepositions/DepositionDetail';
import UserDetail from './ManageUsers/UserDetail';
import UploadProgress from 'src/components/common/UploadProgress';
import ManageRepository from './ManageRepository/DepositionList';
import FinalDepositionDetail from './ManageRepository/FinalDepositionDetail';
import ScheduleDepositionList from './ManageScheduleDeposition/ScheduleDepositionList';
const Routing: React.FC<{}> = props => {
  Navigator.setTopHistory(useHistory());

  return (
    <Screen>
      <Navbar />
      <Sidebar />
      <Switch>
        <CustomRoute path={PATHS.SignIn} component={Signin} />
        <CustomRoute pageRequiredAuth path={PATHS.Root} component={Home} exact />
        <CustomRoute pageRequiredAuth path={PATHS.Dev} component={Dev} />
        <CustomRoute pageRequiredAuth path={`${PATHS.ManageUsers}/:id`} component={UserDetail} />
        <CustomRoute pageRequiredAuth path={PATHS.ManageUsers} component={ManageUsers} />
        <CustomRoute pageRequiredAuth path={`${PATHS.DepositionManagement}/:id`} component={DepositionDetail} />
        <CustomRoute pageRequiredAuth path={PATHS.DepositionManagement} component={ManageDepositions} />
        <CustomRoute pageRequiredAuth path={`${PATHS.RepositoryManagement}/:id`} component={FinalDepositionDetail} />
        <CustomRoute pageRequiredAuth path={`${PATHS.RepositoryManagement}`} component={ManageRepository} />
        <CustomRoute pageRequiredAuth path={PATHS.SchedulingRequests} component={ScheduleDepositionList} />

        <Route component={NotFound} />
      </Switch>
      <AuthContainer />
      <LoadingContainer />
      <ModalContainer />
      <ContentContainer />
      <ToastContainer />
      <ResponsiveContainer />
      <UploadProgress />
    </Screen>
  );
};

export default Routing;

const CRouting: React.FC<Props> = ({ isAuthenticated, userPermissions, pageRequiredAuth, component, ...rest }) => {
  const renderRoute = (Component: any) => (props: RouteProps) => {
    if (isAuthenticated === null) return <SplashScreen />;

    if ((isAuthenticated && pageRequiredAuth) || (!isAuthenticated && !pageRequiredAuth)) {
      // Before render component, check permission first
      // const pathname = props.location?.pathname;
      // const sidebarItem = SidebarMenu.find(item => item.href === pathname);
      return <Component {...props} />;
    }

    const redirectPath = isAuthenticated ? PATHS.Root : PATHS.SignIn;
    const redirectProps = {
      to: {
        pathname: redirectPath,
        state: { from: props.location },
      },
    };
    return <Redirect {...redirectProps} />;
  };

  return <Route {...rest} render={renderRoute(component)} />;
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  RouteProps & { pageRequiredAuth?: boolean };

const mapStateToProps = (state: IAppState) => ({
  isAuthenticated: state.auth.isAuthenticated,
  userPermissions: state.auth.permissions,
});

const mapDispatchToProps = {};

const CustomRoute = connect(mapStateToProps, mapDispatchToProps)(CRouting);
